import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Loader from 'react-loader';

import withServices  from '../../../../HOCs/withServices';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import LessonInfo from '../../../../components/DataCentre/LessonInfo';
import LessonAttempts from '../../../../components/DataCentre/LessonAttempts';
import AttemptPerformance from '../../../../components/DataCentre/AttemptPerformance';

import { Wrapper, Content, ContentRow, ContentCol } from './LessonDetails.styles';


interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedAttempt: string;
}

class LessonDetails extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = { 
      toLogin: false,
      loaded: true,
      data: {},
      selectedAttempt: '',
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
  }

  public async componentDidMount() {
    const {
      location,
      match,
      history,
      services: { isUserLoggedIn, studentsAPI },
    } = this.props;

    if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

    const { state } = location;

    if (state === undefined) {
      history.push('/students/datacentre');
    } else {
      const { params: { id: allocationID } } = match;
      const res = await studentsAPI.getLessonPerformance({ allocationID });

      if (res.ok) {
        this.setState({ data: res.data });
      } else {
        alert('Error fetching student\'s details!');
      }
    }
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public onGoBack() {
    const { history } = this.props;

    history.goBack();
  }

  public onSelectAttempt = (e) => {
    const selectedAttempt = e.target.value;

    this.setState({ selectedAttempt });
  }

  public render() {
    const { data, selectedAttempt } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
            <h1>Lesson: {data.Title}</h1>
            <h5>Course: {data.CourseName}</h5>
          </ContentRow>

          <ContentRow>
            <ContentCol>
              <LessonInfo data={data} />
            </ContentCol>
            <ContentCol>
              <LessonAttempts data={data} />
            </ContentCol>
          </ContentRow>

          <ContentRow className="single-col attempt-selector-row">
            <p>See how you performed in:</p>
            <select
              className="custom-select"
              value={selectedAttempt}
              onChange={this.onSelectAttempt}
            >
              <option value="">--</option>
              {data.Attempts.map((attempt: any, index: number) => {
                return (
                  <option key={attempt.id} value={index}>
                    {attempt.AttemptIdentifier}
                  </option>
                );
              })}
            </select>
          </ContentRow>

          <ContentRow className="single-col">
            <ContentCol>
              <AttemptPerformance
                data={data}
                selectedAttempt={selectedAttempt}
              />
            </ContentCol>
          </ContentRow>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(LessonDetails);



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/LessonDetails/LessonDetails.tsx